
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M26.86 17.547c.06-.482.105-.964.105-1.477 0-.512-.045-.994-.106-1.477l3.18-2.486a.76.76 0 00.181-.965l-3.014-5.214c-.18-.332-.588-.452-.92-.332l-3.752 1.507a11.01 11.01 0 00-2.547-1.476l-.572-3.994A.735.735 0 0018.676 1h-6.028a.735.735 0 00-.738.633l-.573 3.994c-.92.376-1.763.889-2.547 1.476L5.038 5.596a.735.735 0 00-.92.332l-3.014 5.214a.743.743 0 00.181.965l3.18 2.486c-.06.483-.105.98-.105 1.477 0 .497.045.995.105 1.477l-3.18 2.487a.76.76 0 00-.18.964l3.014 5.214c.18.332.587.452.919.332l3.752-1.507a11.01 11.01 0 002.547 1.477l.573 3.993a.735.735 0 00.738.633h6.028a.735.735 0 00.739-.633l.572-3.993c.92-.377 1.764-.89 2.547-1.477l3.753 1.507c.346.136.738 0 .919-.332l3.014-5.214a.76.76 0 00-.18-.964l-3.18-2.487zm-11.198 3.798a5.28 5.28 0 01-5.274-5.275 5.28 5.28 0 015.274-5.274 5.28 5.28 0 015.275 5.274 5.28 5.28 0 01-5.275 5.275z"}})])
          )
        }
      }
    